import { MapPin } from "lucide-react";

export const GoogleMap = ({ address, location, latitude, longitude, title }) => {
  // Build the map URL
  const getMapUrl = () => {
    // If we have coordinates, use them
    if (latitude && longitude) {
      return `https://maps.google.com/maps?q=${latitude},${longitude}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
    }
    
    // Otherwise use address or location
    const query = encodeURIComponent(address || location || "");
    if (query) {
      return `https://maps.google.com/maps?q=${query}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
    }
    
    return null;
  };

  const mapUrl = getMapUrl();

  if (!mapUrl) {
    return (
      <div className="aspect-video bg-muted flex items-center justify-center">
        <div className="text-center">
          <MapPin className="w-8 h-8 text-muted-foreground mx-auto mb-2" />
          <p className="text-muted-foreground text-sm">Location not available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="google-map">
      <div className="flex items-center gap-2">
        <MapPin className="h-5 w-5 text-primary" />
        <h2 className="font-serif text-2xl font-medium">Location</h2>
      </div>
      <div className="relative aspect-video bg-muted overflow-hidden border border-border">
        <iframe
          src={mapUrl}
          title={`Map showing ${title || "property"} location`}
          className="absolute inset-0 w-full h-full"
          frameBorder="0"
          scrolling="no"
          marginHeight="0"
          marginWidth="0"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
          data-testid="google-map-iframe"
        />
      </div>
    </div>
  );
};

export default GoogleMap;
